import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { ChevronRight, User } from 'lucide-react';

const POSITIONING_OPTIONS = [
  { 
    id: 'high_friction', 
    text: 'Je dois intervenir régulièrement pour débloquer des décisions ou faire avancer les sujets.',
    level: 4
  },
  { 
    id: 'medium_friction', 
    text: 'Certains sujets remontent encore régulièrement vers moi.',
    level: 3
  },
  { 
    id: 'low_friction', 
    text: 'L\'équipe fonctionne globalement de manière autonome.',
    level: 2
  },
  { 
    id: 'fluid', 
    text: 'Les décisions et l\'exécution sont fluides sans intervention particulière de ma part.',
    level: 1
  }
];

const ConsequenceQuestion = ({ 
  selectedOption, 
  onSelect, 
  onContinue,
  language = 'fr' 
}) => {

  return (
    <div className="min-h-screen bg-[#0f1c47] flex items-center justify-center p-4">
      <div className="max-w-xl mx-auto w-full">
        {/* Logo */}
        <div className="text-center mb-6">
          <img 
            src="https://customer-assets.emergentagent.com/job_manager-inventory/artifacts/kqdhn43c_2024_10_make_it_matter.png" 
            alt="WEDO" 
            className="mx-auto h-12 object-contain"
          />
        </div>

        <Card className="bg-white border-0 shadow-2xl">
          <CardContent className="p-6 md:p-8">
            {/* Header */}
            <div className="text-center mb-6">
              <div className="w-14 h-14 mx-auto rounded-full bg-gradient-to-br from-[#e62c86] to-[#f3a114] flex items-center justify-center mb-4">
                <User className="w-7 h-7 text-white" />
              </div>
              <p className="text-[#e62c86] font-semibold text-sm uppercase tracking-wide mb-2">
                Une dernière question
              </p>
              <h2 className="text-xl font-bold text-[#0f1c47] leading-relaxed">
                Dans la dynamique actuelle de votre équipe, quelle situation vous correspond le plus aujourd'hui ?
              </h2>
            </div>
            
            {/* Options */}
            <div className="space-y-3 mb-8">
              {POSITIONING_OPTIONS.map((option) => (
                <button
                  key={option.id}
                  onClick={() => onSelect(option)}
                  className={`
                    w-full p-4 rounded-xl text-left transition-all duration-200
                    ${selectedOption?.id === option.id 
                      ? 'bg-[#e62c86] text-white shadow-lg' 
                      : 'bg-gray-50 text-gray-700 hover:bg-gray-100 border border-gray-200'
                    }
                  `}
                >
                  <span className="text-sm font-medium leading-relaxed">{option.text}</span>
                </button>
              ))}
            </div>

            {/* CTA */}
            <Button 
              onClick={onContinue}
              disabled={!selectedOption}
              size="lg"
              className="w-full text-white py-6 text-lg font-bold shadow-lg hover:shadow-xl transition-all border-0 rounded-xl"
              style={{
                background: selectedOption 
                  ? 'linear-gradient(135deg, #e62c86 0%, #f3a114 100%)'
                  : '#ccc'
              }}
            >
              Voir mes résultats
              <ChevronRight className="w-5 h-5 ml-2" />
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ConsequenceQuestion;
